<template>
  <v-dialog v-model="showDuplicateItem" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline grey lighten-3">
        <span class="headline">
          <v-icon class="mr-2">fal fa-users-class</v-icon>Duplicate ({{
            type.toUpperCase()
          }}: {{ item ? item.name : null }})
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="company_id"
                :items="dealers"
                item-value="id"
                item-text="name"
                :menu-props="{ closeOnClick: true }"
                label="Change Curriculum Ownership"
                :disabled="type !== 'course' || loading"
                :loading="loading"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="dealerIds"
                :items="dealers"
                item-value="id"
                item-text="name"
                :menu-props="{ closeOnClick: true }"
                label="Assign to Dealer(s)"
                multiple
                :disabled="type !== 'course' || loading"
                :loading="loading"
              >
                <template v-slot:prepend-item v-if="dealers.length > 0">
                  <v-list-item ripple @click="selectAll">
                    <v-list-item-action>
                      <v-checkbox v-model="selectedAll"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Select All </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-show="index < 3">
                    <span>{{ item.name }}</span>
                  </v-chip>

                  <span v-if="index === 3" class="grey--text caption">
                    (+{{ dealerIds.length - 3 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          text
          @click="duplicateItem"
          >Save</v-btn
        >
        <v-btn
          color="blue-grey"
          :loading="loading"
          :disabled="loading"
          text
          @click="close"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { each as _each } from 'lodash-es';

export default {
  name: 'DuplicateItems',

  props: {
    type: String,
    item: Object,
    value: Boolean,
  },

  data() {
    return {
      dealers: [],
      company_id: null,
      dealerIds: [],
      loading: false,
    };
  },

  computed: {
    showDuplicateItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    selectedAll() {
      return this.dealerIds.length === this.dealers.length;
    },
  },

  created() {
    this.getDealers();
  },

  methods: {
    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.dealerIds = [];
        } else {
          let allIds = this.dealers.slice().map((item) => {
            return item.id;
          });
          this.dealerIds = allIds;
        }
      });
    },

    getDealers() {
      this.axios
        .get('client/lms/fetchMainCompanies')
        .then((response) => {
          this.dealers = response.data;
        })
        .catch((err) => {});
    },

    duplicateItem() {
      this.loading = true;
      this.axios
        .post('/lms-manager/duplicate/' + this.type, {
          id: this.item.id,
          dealers: this.dealerIds,
          company_id: this.company_id,
        })
        .then((response) => {
          this.$notify(
            'success',
            'Duplication of item is processing. (May take some time to complete)!'
          );
        })
        .catch((err) => {
          this.$notify('error', 'Encountered error, Please try again!');
        })
        .finally((response) => {
          this.loading = false;
          this.close();
        });
    },

    close() {
      this.dealerIds = [];
      (this.company_id = null), (this.showDuplicateItem = false);
    },
  },
};
</script>
